const fastAbortBatch = (batch, aborts) => {
  batch.items.forEach(_ref => {
    var _aborts$id;
    let {
      id
    } = _ref;
    return (_aborts$id = aborts[id]) === null || _aborts$id === void 0 ? void 0 : _aborts$id.call(aborts);
  });
};
const fastAbortAll = aborts => {
  Object.values(aborts).forEach(fn => fn());
};
export { fastAbortAll, fastAbortBatch };